import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SimpleDialogData } from '../../../../interfaces/simple-dialog-data.interface';
import { IBreadcrumbData } from '../../../../interfaces/breadcrumb-data.interface';
import { SimpleDialogService } from '../../../../services/simple-dialog.service';
import { mergeAll, tap } from 'rxjs/operators';
import { CapacityEditComponent } from '../../components/capacity/edit/edit.component';
import { CapacityDataSource } from '../../data-sources/capacity.data-source';
import { Capacity } from '../../models/capacity';
import { CapacityService } from '../../services/capacity.service';
import { of } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'capacity',
  templateUrl: './capacity.component.html',
  styleUrls: ['./capacity.component.scss'],
})
export class CapacityComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['type', 'description', 'value', 'definition', 'active','slots','action'];

  /**
   * Table config array
   */
  tableConfig: any[] = [
    {
      columnName: 'Tipo',
    },
    {
      columnName: 'Descripción',
    },
    {
      columnName: 'Aforo',
    },
    {
      columnName: 'Definicion',
    },
    {
      columnName: 'Activo',
    },
    {
      columnName: 'Slots',
    },
    {
      columnName: '',
    },
  ];

  /**
   * BreadcrumbData
   */
  breadcrumbData: IBreadcrumbData;

  /**
   * MasterVehicle data source
   */
  capacityDataSource: CapacityDataSource;

  /**
   * Paginator
   */
  @ViewChild(MatPaginator) paginator: MatPaginator;

  /**
   * Sort
   */
  @ViewChild(MatSort) sort: MatSort;

  /**
   * Filter object
   */
  filter: any;

  /**
   * Count of total departments
   */
  totalCapacities: number;

  constructor(private capacityService: CapacityService, public dialog: MatDialog, private simpleDialogService: SimpleDialogService) {
    this.breadcrumbData = {
      titles: {
        icon: 'directions_car',
        links: [
          {
            text: 'Lista Aforos',
          },
        ],
      },
      buttons: [
        {
          text: 'Crear',
          action: () => this.create(),
          icon: 'add',
          disabled: false
        },
      ],
    };
  }

  ngOnInit(): void {
    this.capacityDataSource = new CapacityDataSource(this.capacityService);
    this.capacityDataSource.load();
    this.capacityService.getCount().subscribe((data: { count: number }) => (this.totalCapacities = data.count));
  }

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    of(this.sort.sortChange, this.paginator.page)
      .pipe(
        mergeAll(),
        tap(() => this.loadCapacities())
      )
      .subscribe();
  }

  /**
   * Load capacities
   */
  loadCapacities(): void {
    this.capacityDataSource.load(this.sort.active, this.sort.direction, this.paginator.pageSize, this.paginator.pageIndex, this.filter);

    this.capacityService
      .getCount('id', this.sort.direction, this.paginator.pageSize, this.paginator.pageIndex, this.filter)
      .subscribe((data: { count: number }) => (this.totalCapacities = data.count));
  }

  /**
   * Create
   */
  create(): void {
    const dialogRef = this.dialog.open(CapacityEditComponent, { width: '450px', disableClose: true });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadCapacities();
      }
    });
  }

  /**
   * Edit
   *
   * @param capacity Capacity instance
   */
  edit(capacity: Capacity): void {
    const dialogRef = this.dialog.open(CapacityEditComponent, {
      width: '450px',
      disableClose: true,
      data: {
        id: capacity.id,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loadCapacities();
      }
    });
  }

  /**
   * Remove
   *
   * @param capacity Capacity instance
   */
  remove(capacity: Capacity): void {
    const data: SimpleDialogData = {
      title: 'Warning!',
      message: `Quieres eliminar el aforo ${capacity.id}?`,
      rightButtonText: 'Yes',
    };

    this.simpleDialogService.open(data).subscribe((response) => {
      if (response) {
        this.capacityService.delete(capacity.id).subscribe(() => this.loadCapacities());
      }
    });
  }
}
